import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'

import * as actions from '../actions'
// default home components
class Home extends React.Component {
  componentDidMount () {
    console.log(this.props.user)
    if (this.props.user.userId) {
      this.props.history.push('/authorize')
    } else {
      this.props.history.push('/login')
    }
  }

  render () {
    return <div>Home</div>
  }
}

export default connect(
  state => ({
    user: state.userInfo
  }),
  dispatch => bindActionCreators({ ...actions }, dispatch)
)(withRouter(Home))
